// extracted by mini-css-extract-plugin
module.exports = {"ProblemDetailsPage":"ProblemDetailsPage_ProblemDetailsPage__1qIbF","ToSolveDisclaimer":"ProblemDetailsPage_ToSolveDisclaimer__2cj4D"};